import React from 'react';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="bg-[#f0f4ee] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-14 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

          {/* Left column */}
          <div className="space-y-6">
            {/* Kicker */}
            <div className="flex items-center space-x-2 text-primary text-xs font-semibold uppercase tracking-widest">
              <Icon name="Zap" size={13} className="text-primary" />
              <span>Thuisbatterijen · GRP Grafeentechnologie</span>
            </div>

            {/* H1 */}
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 leading-tight">
              Stop met stroom<br />weggeven,{' '}
              <span className="text-primary">sla het op</span>
            </h1>

            {/* Body text */}
            <p className="text-base text-gray-700 leading-relaxed max-w-lg">
              De salderingsregeling stopt op <strong>1 januari 2027</strong>. Met een GRP-thuisbatterij gebruik je je eigen stroom wanneer jíj die nodig hebt — geleverd, geïnstalleerd en beheerd via Verduurzaamwijzer.nu.
            </p>

            {/* Bullets — 2-column grid */}
            <div className="grid grid-cols-2 gap-x-6 gap-y-2">
              {[
                'Volledig geïnstalleerd',
                'Kiwa-getest (UN 38.3)',
                'GRP Grafeentechnologie',
              ]?.map((item) => (
                <div key={item} className="flex items-center space-x-2">
                  <Icon name="Check" size={14} className="text-primary flex-shrink-0" />
                  <span className="text-sm text-gray-800">{item}</span>
                </div>
              ))}
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-3 pt-2">
              <button
                onClick={() => scrollTo('formulier')}
                className="inline-flex items-center justify-center px-6 py-3.5 bg-primary text-white font-semibold rounded-md hover:bg-primary/90 transition-all duration-200 shadow-sm"
              >
                Plan een gratis adviesgesprek →
              </button>
              <button
                onClick={() => scrollTo('rekenhulp')}
                className="inline-flex items-center justify-center px-6 py-3.5 text-gray-900 font-semibold border border-gray-300 rounded-md bg-white hover:bg-gray-50 transition-colors"
              >
                Bereken je besparing ↓
              </button>
            </div>
          </div>

          {/* Right column — image */}
          <div className="flex items-center justify-center lg:justify-end">
            <img
              src="/assets/images/hero_variant_5-1783434686498.png"
              alt="GRP thuisbatterijen — grafeen en lithium modellen met klantreviews"
              className="w-full max-w-xl object-contain"
            />
          </div>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;
